"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcConditionalWrapper = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Wrap children if condition met
 * This only checks for HTML children
 * React Component children will always render
 */
var AcConditionalWrapper = function (_a) {
    var condition = _a.condition, ifHTMLChildren = _a.ifHTMLChildren, wrapperWithChildren = _a.children;
    if (!wrapperWithChildren) {
        console.error('Error: No wrapper provided');
        return null;
    }
    try {
        react_1.default.Children.only(wrapperWithChildren);
    }
    catch (_b) {
        console.error('Error: More than one child.  Wrapper must be immediate child. (No changes made.)');
        return react_1.default.createElement(react_1.default.Fragment, null, wrapperWithChildren);
    }
    var childrenOfWrapper = wrapperWithChildren.props.children;
    if (ifHTMLChildren) {
        var validChildrenOfWrapper = react_1.default.Children.toArray(childrenOfWrapper);
        if (validChildrenOfWrapper.length === 0) {
            return null;
        }
        react_1.default.Children.forEach(validChildrenOfWrapper, function (childOfWrapper) {
            var _a;
            if ((_a = childOfWrapper.type) === null || _a === void 0 ? void 0 : _a.name) {
                console.warn('A child of Conditional Wrapper is a React Component.  This will always be counted as a valid child, even if it renders nothing.  This is okay only if the components are conditionally rendered.');
            }
        });
        return wrapperWithChildren;
    }
    else if (typeof condition === 'boolean') {
        if (condition) {
            return wrapperWithChildren;
        }
        else {
            return react_1.default.createElement(react_1.default.Fragment, null, childrenOfWrapper);
        }
    }
    else if (typeof condition === 'function') {
        if (condition(childrenOfWrapper)) {
            return wrapperWithChildren;
        }
        else {
            return react_1.default.createElement(react_1.default.Fragment, null, childrenOfWrapper);
        }
    }
    return wrapperWithChildren;
};
exports.AcConditionalWrapper = AcConditionalWrapper;
exports.AcConditionalWrapper.displayName = 'AcConditionalWrapper';
//# sourceMappingURL=AcConditionalWrapper.js.map